import React from 'react'
import AuditLog from 'duties/overview/audit-log'
import Card from 'react-bootstrap/Card'

function AuditLogTab({ employeeId }) {
  return (
    <Card className="border">
      <Card.Body>
        <AuditLog userId={employeeId} />
      </Card.Body>
    </Card>
  )
}

export default AuditLogTab
